import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'

import { getItemValue } from './getItemValue'

export interface IGetTwoYearsSum {
  formats: IFormActualsTargetsSettings[]
  settingsIndex: number
  items: IJBPPlanningItem[]
  fyear: number
  isGetUnits: boolean
  isAddContractual: boolean

  actualsType: ActualsValueTypes
  isDirect: boolean

  isComposedCompletedPlans: boolean
  isComposedSob: boolean
}

export const getTwoYearsSum = ({
  formats,
  settingsIndex,
  items,
  fyear,
  isGetUnits,
  isAddContractual,

  actualsType,
  isDirect,

  isComposedCompletedPlans,
  isComposedSob,
}: IGetTwoYearsSum): number => {
  let sum = 0

  const fieldProps = {
    isUnits: false,
    isShipment: false,
    currency: 'USD',
    sType: '',
    isSoB: false,

    actualsType,
    isDirect,

    isComposedCompletedPlans,
    isComposedSob,
  }

  if (settingsIndex < formats.length) {
    const setting = formats[settingsIndex]

    // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
    // 1. Prev and Current year
    // 2. All Quarters
    const sourceData = items.filter(
      (el) =>
        el.ProgramTypes === setting.ProgramType &&
        el.Category === setting.Category &&
        el.SubCategory === setting.SubCategory &&
        el.L3Category === setting.L3Category &&
        (el.FYear === fyear || el.FYear === fyear - 1)
    )
    sourceData.forEach((item) => {
      sum += getItemValue(item, { ...fieldProps, isUnits: isGetUnits, sType: '' }) || 0

      if (isAddContractual) {
        sum += getItemValue(item, { ...fieldProps, isUnits: isGetUnits, sType: 'c' }) || 0
        //sum += getItemValue(item, { ...fieldProps, isUnits: isGetUnits, sType: 't' }) || 0 // Dont need it
      }
    })
  }

  return sum
}
